import { useState } from 'react';
import { Link } from 'react-router-dom';
import servicesData from '../../../data/services-data';

const Services = () => {
    const [active, setActive] = useState(1);

    const handelActive = (index) => {
        setActive(index);
    };

    return (
        <>
        </>
    );
};

export default Services;
